/* eslint-disable react-perf/jsx-no-new-function-as-prop */
/* eslint-disable react/no-multi-comp */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { trackAction } from 'app/shared/utils/tracking';
import { noop } from 'app/shared/utils/utils';
import { NEWSLETTER_SOURCE } from 'app/marketplace/crm/constants';
import { NewsletterSignupForm } from 'app/shared/components/NewsletterSignupForm/NewsletterSignupForm';
import { useSlideIn } from 'app/marketplace/SlideInBanners/shared/hooks/desktop/useSlideIn';
import { useStyledTheme } from 'app/shared/hooks/useStyledTheme';

import {
  HeadingSt,
  IconCloseSt,
  ImageSt,
  ImageWrapperSt,
  ModalSt,
  ModalWrapperSt,
  SuccessTextSt,
  TextSt,
} from './DesktopBanner.css';

export const trackSubmit = () => ({
  init: () =>
    trackAction('slide_in_crm_submit_initialized', {
      category: 'slide_in',
      description: 'user submits email address in slide-in crm',
      label: 'newsletter_signup',
    }),
  success: () =>
    trackAction('slide_in_crm_submit_successful', {
      category: 'slide_in',
      description: 'user successfully submits email address in slide-in crm',
      label: 'newsletter_signup',
    }),
  fail: () => {
    trackAction('slide_in_crm_submit_failed', {
      category: 'slide_in',
      description: 'user fails to submit email address in slide-in crm',
      label: 'newsletter_signup',
    });
  },
});

const trackingRender = () =>
  trackAction('slide_in_crm_displayed_on_desktop', {
    category: 'slide_in',
    description: 'user views crm slide-in on desktop',
    label: 'newsletter_signup',
  });

export const DesktopBanner = ({
  onFormSubmit,
  finishSubmit,
  onClose,
  areCookiesAccepted,
  done,
  threshold,
  submitted,
}) => {
  const { colors } = useStyledTheme();
  const [hide] = useState(submitted);
  const [mode, changedToVisible] = useSlideIn(threshold);

  useEffect(() => {
    if (changedToVisible) {
      trackingRender();
    }
  }, [changedToVisible]);

  const renderForm = () => (
    <ModalWrapperSt background={colors.sunbeanLighter} isFlex>
      <div>
        <HeadingSt>Immer auf dem neuesten Stand</HeadingSt>
        <TextSt>
          Erhalte aktuelle Angebote und hilfreiche Informationen zu deiner
          Fahrzeugsuche
        </TextSt>
        <NewsletterSignupForm
          onFormSubmit={onFormSubmit}
          onSuccess={finishSubmit}
          trackSubmit={trackSubmit}
          alignMessage="left"
          placeholder="E-Mail-Adresse"
          source={NEWSLETTER_SOURCE.slideIn}
        />
      </div>
      <ImageWrapperSt width={138}>
        <ImageSt src="/assets/slideInCar.png" />
      </ImageWrapperSt>
    </ModalWrapperSt>
  );

  const renderSuccess = () => (
    <ModalWrapperSt background="white" isFlex column alignCenter justifyCenter>
      <ImageWrapperSt width={104}>
        <img src="/assets/mailtrain/subscription.svg" alt="" />
      </ImageWrapperSt>
      <SuccessTextSt>
        Wir haben dir eine E-Mail geschickt. Bitte bestätige deine Anmeldung!
      </SuccessTextSt>
    </ModalWrapperSt>
  );

  const closeModal = () => {
    trackAction(
      `slide_in_crm_closed_${done ? 'after_submit' : 'without_submit'}`,
      {
        category: 'slide_in',
        description: `user closes slide-in crm ${
          done ? 'after form submission' : 'without submitting form'
        }`,
        label: 'newsletter_signup',
      },
    );
    onClose(areCookiesAccepted);
  };

  // When component mounts, check if form has been previously submitted
  // if yes, do not render
  if (hide) return null;

  return (
    <ModalSt mode={mode}>
      <IconCloseSt
        className="if-icon-close"
        onClick={closeModal}
        data-testid="icon-close-newsletter-desktop"
      />
      {done ? renderSuccess() : renderForm()}
    </ModalSt>
  );
};

DesktopBanner.propTypes = {
  onFormSubmit: PropTypes.func,
  finishSubmit: PropTypes.func,
  submitted: PropTypes.bool,
  onClose: PropTypes.func,
  areCookiesAccepted: PropTypes.bool,
  done: PropTypes.bool,
  threshold: PropTypes.number.isRequired,
};

DesktopBanner.defaultProps = {
  onFormSubmit: noop,
  finishSubmit: noop,
  submitted: false,
  onClose: noop,
  done: false,
  areCookiesAccepted: false,
};
